export default __webpack_public_path__ + "static/media/gallery_04.665c6a3f.jpg";